import React from "react";
import Form from "react-bootstrap/Form";
import { useField } from "formik";
import clsx from "clsx";
import { FormCheckType } from "react-bootstrap/FormCheck";
import { includes } from "lodash";
import { useIntl } from "react-intl";

export const SimpleFormCheck: React.FC<{
    index?: number;
    label?: string | React.ReactNode;
    name: string;
    type?: FormCheckType;
    value?: number | string;
    cssClass?: string[];
}> = (props) => {
    const { label, name, type = "switch", cssClass, value, index = 0 } = props;
    const { formatMessage } = useIntl();
    const [formikProps, meta] = useField(name);
    return (
        <div>
            <div>
                <Form.Check
                    id={`${name}${index}`}
                    className={clsx(
                        cssClass || [],
                        {
                            "is-invalid": !!meta.error,
                        },
                        {
                            "is-valid": meta.touched && !meta.error,
                        }
                    )}
                    type={type}
                    checked={
                        (includes(formikProps.value, value?.toString()) ||
                            formikProps.value == value ||
                            (formikProps.value === true && formikProps.value !== 1)) &&
                        formikProps.value != undefined
                    }
                    label={label}
                    {...formikProps}
                    value={value}
                    name={name}
                />
            </div>

            {meta.touched && meta.error && (
                <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                        <span role="alert">
                            {meta.error.includes("error.")
                                ? formatMessage({ id: meta.error })
                                : meta.error}
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
};
